import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Box,
  UnorderedList,
  ListItem,
  Flex
} from "@chakra-ui/react";

const ImportantNotice = ({ setShowDisclaimer, navigate }) => {
  
  const handleCloseNavigate = () => {
    setShowDisclaimer(false);
    navigate("/pricing");
  };

  return (
    <Modal isOpen={true} size={{base: "xs", lg: "lg"}} onClose={() => setShowDisclaimer(false)}>
      <ModalOverlay />
      <ModalContent bgColor={"brand.black"} borderRadius={"xl"}>
        <ModalHeader
          textAlign={"center"}
          color={"brand.red"}
          fontFamily={"heading"}
          fontWeight={400}
          fontSize={"2xl"}
        >
          New Pricing, Bigger Savings!
        </ModalHeader>
        <ModalCloseButton color={"brand.white"} outline={"none"} />
        <ModalBody>
          <Box pb={2} px={"30px"}>
            <Text textAlign={"start"} color={"brand.white"}>
              Cut your Solana infra costs with our latest plans:
            </Text>
            <Box color={"brand.white"}>
              <UnorderedList>
                <ListItem>RPC — no credit limits</ListItem>
                <ListItem>gRPC — no IP restrictions</ListItem>
              </UnorderedList>
            </Box>
          </Box>
            <Flex justifyContent={"center"} alignItems={"center"}>
              <Box pt={2} pb={4} textAlign={"center"} mx={"4px"}>
                <Button
                  bgColor={"brand.red"}
                  fontFamily={"heading"}
                  color={"brand.white"}
                  _hover={{ bg: "brand.white", color: "brand.red" }}
                  borderRadius={"full"}
                  fontWeight={400}
                  fontSize={"sm"}
                  letterSpacing={"0.01rem"}
                  px={6}
                  size={"sm"}
                  onClick={handleCloseNavigate}
                >
                  View Plans
                </Button>
              </Box>
              <Box pt={2} pb={4} textAlign={"center"} mx={"4px"}>
                <Button
                  onClick={() => setShowDisclaimer(false)}
                  border={"2px solid"}
                  borderColor={"brand.red"}
                  bgColor={"transparent"}
                  fontFamily={"heading"}
                  color={"brand.white"}
                  _hover={{ bg: "brand.red", color: "brand.white" }}
                  borderRadius={"full"}
                  fontWeight={400}
                  fontSize={"sm"}
                  letterSpacing={"0.01rem"}
                  px={6}
                  size={"sm"}
                >
                  Close
                </Button> 
                
              </Box>
            </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ImportantNotice;
